import React, { useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";
import { getMuthootResponsibleDepartments } from "./service";

const useStyles = makeStyles(() => ({
  title: {
    fontFamily: "Satoshi-Bold",
  },
  hint: {
    fontSize: "14px",
    color: "#4F4F4F",
    marginBottom: "1.25rem",
  },
  loader: {
    display: "flex",
    justifyContent: "center",
    padding: "1rem 0",
  },
  error: {
    marginTop: "0.75rem",
    fontSize: "14px",
    color: "#D32F2F",
  },
  actions: {
    padding: "16px 24px 24px",
  },
  button: {
    textTransform: "none",
  },
}));

export default function ResponsibleDepartmentDialog({ open, onClose, onSubmit }) {
  const classes = useStyles();

  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [loadingDepartments, setLoadingDepartments] = useState(false);
  const [error, setError] = useState("");

  // Start every opening with a fresh list and no previous pick.
  useEffect(() => {
    if (!open) return;
    setSelectedDepartment("");
    setError("");
    setLoadingDepartments(true);
    getMuthootResponsibleDepartments()
      .then((res) => {
        setDepartments(res.data?.responsible_department || []);
      })
      .catch((err) => {
        console.log(err);
        setError("Could not load the list of departments. Please try again.");
      })
      .finally(() => {
        setLoadingDepartments(false);
      });
  }, [open]);

  const handleSubmit = () => {
    if (!selectedDepartment) {
      setError("Please select the responsible department.");
      return;
    }
    onSubmit(selectedDepartment);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle disableTypography>
        <Typography variant="h6" className={classes.title}>
          Responsible Department
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography className={classes.hint}>
          Select the department responsible for this grievance.
        </Typography>
        {loadingDepartments ? (
          <div className={classes.loader}>
            <CircularProgress size={28} />
          </div>
        ) : (
          <FormControl fullWidth variant="outlined" size="small">
            <InputLabel id="responsible-department-label">Department</InputLabel>
            <Select
              labelId="responsible-department-label"
              label="Department"
              value={selectedDepartment}
              onChange={(e) => {
                setSelectedDepartment(e.target.value);
                setError("");
              }}
              disabled={departments.length === 0}
            >
              {departments.map((department) => (
                <MenuItem key={department} value={department}>
                  {department}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        {error && <Typography className={classes.error}>{error}</Typography>}
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button variant="outlined" onClick={onClose} className={classes.button}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={loadingDepartments || departments.length === 0}
          className={classes.button}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}
